module.exports = __webpack_public_path__ + "static/media/01_escala-burnaby.fa517e0f.jpg";